<template>
<div class="leaps-meditation-list">
<div class="container-fluid" v-if="getLeapsMeditationList.length > 0">
  <div class="table-responsive margin-Top-6Perc" >
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right cursor-pointer">
            <span @click="selectedColumn('MeditationTitle', 'asc', false)">Meditation Title</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currMeditationNameSortOrder === 'desc'}" @click="selectedColumn('MeditationTitle', 'desc', true)">&#9660;</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currMeditationNameSortOrder === 'asc'}" @click="selectedColumn('MeditationTitle', 'asc', true)">&#9650;</span>
          </th>
          <th class="text-align-center font-size-15px border-right">Created TS</th>
          <th class="text-align-center font-size-15px border-right">Updated TS</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="currLeapsMeditationObj in getLeapsMeditationList" :key="currLeapsMeditationObj.MeditationLibraryId" :currLeapsMeditationObj="currLeapsMeditationObj">
          <td class="border-right text-align-center col-lg-5 col-md-5 border-right">{{currLeapsMeditationObj.MeditationTitle}}</td> 
          <td class="text-align-center col-lg-2 col-md-2 border-right">{{formatAndShowDate(currLeapsMeditationObj.CreatedTS)}}</td>
          <td class="text-align-center col-lg-2 col-md-2 border-right">{{formatAndShowDate(currLeapsMeditationObj.UpdatedTS)}}</td>
          <td class="text-align-center col-lg-3 col-md-3">
            <a class="cursor-pointer" @click="performClickOperation($event,'edit', currLeapsMeditationObj)"> Edit </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'view', currLeapsMeditationObj)"> View </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete', currLeapsMeditationObj)"> Delete </a>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <update-leaps-meditation-overlay v-if="openEditOverlay" :currSelectedObj="currSelectedObj" @emittedValue="updateEmittedValue"></update-leaps-meditation-overlay>
  <view-leaps-meditation-overlay v-if="openViewOverlay" :currSelectedObj="currSelectedObj" @emittedValue="updateEmittedValue"></view-leaps-meditation-overlay>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteCurrentLeapsMeditation"></confirmation-alert>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import { leapsMeditationService } from '@/server-util/leaps-meditation-service'
import UpdateLeapsMeditationOverlay from '@/components/leaps/meditation/UpdateLeapsMeditationOverlay'
import ViewLeapsMeditationOverlay from '@/components/leaps/meditation/ViewLeapsMeditationOverlay'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import Loader from '@/components/dashboard/Loader'
import findIndex from 'lodash/findIndex'
export default {
  props: ['leapsMeditationList'],
  computed: {
    getLeapsMeditationList: {
      get: function () {
        return this.leapsMeditationList
      }
    }
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      currSelectedObj: null,
      openEditOverlay: false,
      openViewOverlay: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      currMeditationNameSortOrder: ''
    }
  },
  name: 'leaps-meditation-list',
  methods: {
    selectedColumn: function (currSelectedColumn, orderBy = 'asc', clickedOnArrow) {
      var emitVal = false
      switch (currSelectedColumn) {
        case 'MeditationTitle':
          if (clickedOnArrow) {
            if (this.currMeditationNameSortOrder === orderBy) {
              currSelectedColumn = 'MeditationTitle'
              emitVal = false
            } else {
              this.currMeditationNameSortOrder = orderBy
              emitVal = true
            }
          } else {
            if (this.currMeditationNameSortOrder === '') {
              orderBy = 'asc'
            } else {
              orderBy = this.currMeditationNameSortOrder === 'asc' ? 'desc' : 'asc'
            }
            currSelectedColumn = 'MeditationTitle'
            this.currMeditationNameSortOrder = orderBy
            emitVal = true
          }
          if (emitVal) {
            var objToEmit = {
              updateValues: true,
              SortType: orderBy,
              ColumnName: currSelectedColumn
            }
            this.$emit('sortBasedOnColumnName', objToEmit)
          }
          break
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
      this.currSelectedObj = null
    },
    updateEmittedValue (recievedObj) {
      this.openEditOverlay = !recievedObj.closeOverlay
      this.openViewOverlay = !recievedObj.closeOverlay
      this.$store.state.isOverlayVisible = false
      var objToEmit = {
        updateValues: false,
        SortType: '',
        ColumnName: ''
      }
      this.$emit('sortBasedOnColumnName', objToEmit)
    },
    performClickOperation: function (event, operationName, selectedObj) {
      this.currSelectedObj = selectedObj
      switch (operationName) {
        case 'edit':
          this.openEditOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'view':
          this.openViewOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to delete '
          this.postString = '\'' + this.currSelectedObj.MeditationTitle + '\' meditation?'
          break
      }
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    deleteCurrentLeapsMeditation (value) {
      this.showConfirmationBox = false
      if (value) {
        var storeObj = this.$store
        if (
          this.currSelectedObj.MeditationLibraryId !== undefined &&
          this.currSelectedObj.MeditationLibraryId !== null
        ) {
          this.$store.state.isLoading = true
          leapsMeditationService
            .deleteLeapsMeditation(
              storeObj.state.access_token,
              this.currSelectedObj.MeditationLibraryId
            )
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  this.checkAndDeleteFromMasterLeapMeditationList()
                  this.$store.state.isLoading = false
                  var objToEmit = {
                    updateValues: false,
                    SortType: '',
                    ColumnName: ''
                  }
                  this.$emit('sortBasedOnColumnName', objToEmit)
                } else {
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                  this.$store.state.isLoading = false
                }
              },
              errorObj => {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = errorObj.response.data.statusText
              }
            )
        } else {
          console.log(
            'MeditationLibraryId is NULL hence declined DELETE LEAP MEDITATION Operation'
          )
        }
      }
    },
    checkAndDeleteFromMasterLeapMeditationList: function () {
      const foundIndex = findIndex(this.$store.state.leapsMeditationList, (obj) => {
        return obj.MeditationLibraryId === this.currSelectedObj.MeditationLibraryId
      })
      if (foundIndex > -1) {
        this.$store.state.leapsMeditationList.splice(foundIndex, 1)
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'update-leaps-meditation-overlay': UpdateLeapsMeditationOverlay,
    'view-leaps-meditation-overlay': ViewLeapsMeditationOverlay,
    'confirmation-alert': ConfirmationOverlay
  }
}
</script>
<style scoped>
.margin-left-0px {
  margin-left: 0px !important;
}
.margin-right-0px {
  margin-right: 0px !important;
}
.font-size-13px {
  font-size: 13px;
}
.float-right {
  float: right;
}
.opacity-1 {
  opacity: 1 !important;
}
.opacity-0Point2 {
  opacity: 0.2;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.leaps-meditation-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/leaps/meditation/LeapsMeditationList.vue